import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { uniqueId } from 'lodash';
import { format } from 'date-fns';
import * as Yup from 'yup';
import { filesize } from 'filesize';
import { toast } from 'react-toastify';
import Dropzone from 'react-dropzone';
import { Interweave } from 'interweave';

import { show } from 'store/modules/dialog/actions';
import api from 'services/api';
import { validateEmail } from 'utils/validators';
import {
  Setor,
  Status,
  StatusBaixa,
  StatusPreAvaliacao,
  StatusWeb,
  StatusCaption,
  Tipo,
  StatusArquivo,
} from 'utils/variables';

import Card from 'components/Card';
import Button from 'components/Button';
import Flag from 'components/Flag';
import Timeline from 'components/Timeline';
import Tooltip from 'components/Tooltip';
import AsyncSelect from 'components/AsyncSelect';
import SelectCreatable from 'components/SelectCreatable';
import Spinner from 'components/Spinner';
import DatePicker from 'components/DatePicker';
import Checkbox from 'components/Checkbox';
import TextArea from 'components/TextArea';
import PlayerBaixa from 'components/PlayerBaixa';

import {
  FiArrowLeft,
  FiLink,
  FiEdit,
  FiX,
  FiUpload,
  FiInfo,
  FiPlay,
  FiPlus,
  FiTrash2,
  FiEdit2,
  FiArchive,
  FiDollarSign,
} from 'react-icons/fi';
import { FaScrewdriver } from 'react-icons/fa';
import { AiTwotoneAudio } from 'react-icons/ai';
import PerfectScrollbar from 'react-perfect-scrollbar';

import notfound from 'assets/semimagem.png';
import {
  Container,
  LeftContent,
  RightContent,
  ContentCards,
  CardContent,
  Midia,
  Info,
  DropContainer,
  Upload,
  Image,
  ThumbnailContainer,
  ButtonUpload,
  ButtonUploadError,
  Aprovacao,
  CircularContainer,
  FormAprovadores,
  Scroll,
  FormFinalizar,
  ListAprovadores,
  Item,
  UserInfo,
  Actions,
  SectionDate,
  ColumnContent,
  Exibidoras,
  PatrocinioItem,
  RoteiroScroll,
  DadosProducao,
} from './styles';

import processImage from 'assets/proccess.jpeg';
import Tabs, { Tab } from 'components/Tabs';
import Avatar from 'components/Avatar';
import {
  Chamada as IChamada,
  Emissora,
  Usuario,
  ChamadaEmissora,
} from 'pages/@types';
import midiainfo from 'utils/midiainfo';
import AppError from 'utils/AppError';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import getValidationErrors from 'services/getValidationErros';
import { useModal } from 'hooks/modal';
import Input from 'components/Input';

interface MXFFile extends File {
  progress: number;
  uploaded: boolean;
  error: boolean;
}

interface EmailOption {
  label: string;
  value: string;
  emissora?: Emissora;
  __isNew__: boolean;
}
interface Email {
  email: string;
  emissora?: Emissora;
  setor?: string;
}

// configuração do validator
const schema = Yup.object().shape({
  datainicio: Yup.date()
    .required('Data de início obrigatória')
    .typeError('Data de início inválida'),
  datafim: Yup.date()
    .required('Data de fim obrigatória')
    .typeError('Data de fim inválida'),
  emissora_ids: Yup.string().required('Selecione pelo menos uma emissora'),
});

export default function Chamada() {
  /**
   * USE STATE
   */
  const [chamada, setChamada] = useState<IChamada>({} as IChamada);
  const [emailsCompleto, setEmailsCompleto] = useState<EmailOption[]>([]);
  const [selectedAprovador, setSelectedAprovador] = useState<Usuario>(
    {} as Usuario,
  );
  const [mxfFile, setMxfFile] = useState<MXFFile[]>([]);
  const [loading, setLoading] = useState(true);
  const [loadingAprovador, setLoadingAprovador] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [inputEmail, setInputEmail] = useState('');
  const [, setLoadingSubmit] = useState(false);
  const [asyncLoading, setAsyncLoading] = useState(false);
  const [emissoras, setEmissoras] = useState<Emissora[]>([]);
  const [activeTabIndex, setActiveTabIndex] = useState(2);
  const [player, setPlayer] = useState({
    open: false,
    midia_url: '',
    pipe: false,
  });
  const { showModal, hideModal } = useModal();
  const navigate = useNavigate();
  /**
   * REDUX
   */
  const dispatch = useDispatch();
  const { callback: callbackDialog } = useSelector(
    (state: any) => state.dialog,
  );
  const { profile } = useSelector((state: any) => state.usuario);

  /**
   * USE PARAMS
   */
  const { chamadaId } = useParams<{ chamadaId: string }>();

  /**
   * USE REF
   */
  const formAprovadoresRef = useRef<FormHandles>(null);
  const formFinalizarRef = useRef<FormHandles>(null);
  const formDescricaoRef = useRef<FormHandles>(null);
  /**
   * FUNÇÕES
   */

  const disableEdit = useCallback(
    (ch: IChamada) => {
      if (loading || asyncLoading || loadingAprovador || loadingStatus)
        return true;
      if (
        [Status.ENTREGUE, Status.FINALIZADO].includes(ch.status) ||
        (profile.setor === Setor.OPEC && ch.tipo === Tipo.VINHETA && ch.midia)
      )
        return true;
      // if (
      //   ch.editor &&
      //   ch.editor.id !== profile.id &&
      //   !ch.aprovadores.some(
      //     (a: ChamadaAprovador) => a.usuario.id === profile.id,
      //   )
      // )
      //   return true;
      // if (
      //   profile.role !== Role.ADMIN &&
      //   profile.role !== Role.PROMO &&
      //   (profile.role !== Role.OPEC ||
      //     (profile.role === Role.OPEC && ch.tipo !== Tipo.VINHETA))
      // )
      //   return true;
      return false;
    },
    // [
    //   asyncLoading,
    //   loading,
    //   loadingAprovador,
    //   loadingStatus,
    //   profile.id,
    //   profile.role,
    // ],
    [asyncLoading, loading, loadingAprovador, loadingStatus, profile.setor],
  );

  // const handleBack = useCallback(() => {
  //   navigate(-1);
  // }, []);

  // const handleEdit = useCallback(id => {
  //   navigate(`/chamadas/${id}`);
  // }, []);

  // const handleClosedCaption = useCallback(id => {
  //   navigate(`/closedcaptioneditor/${id}`);
  // }, []);

  const handlePatrocinioInfoDialog = useCallback(
    pat => {
      const cliente = pat.comercial.cliente
        ? pat.comercial.cliente.mnemonico
        : 'SEM CLIENTE';
      const agencia = pat.comercial.agencia
        ? pat.comercial.agencia.mnemonico
        : 'SEM AGÊNCIA';

      const contentHTML = pat.comercial
        ? `<p>Titulo: ${pat.comercial.titulo}</p>
    <p>Duracao: ${pat.comercial.duracao} s</p>
    <p>Tipo: ${pat.comercial.categoria}</p>
    <p>Status: ${pat.status}</p>
    <p>Data recebimento: ${format(
      new Date(pat.comercial.created_at),
      'dd/MM/yyyy - HH:mm',
    )}</p>
    <p>Agencia: ${agencia}</p>
    <p>Cliente: ${cliente}</p>`
        : `<p>Informações pendentes<p>`;
      const options = {
        type: 'info',
        contentHTML,
        allowOutsideClick: false,
        cancelButtonText: 'OK',
        showConfirmButton: false,
      };
      dispatch(show(options));
    },
    [dispatch],
  );

  const handleMidiaInfoDialog = useCallback(() => {
    if (
      chamada &&
      chamada.midia &&
      chamada.midiainfo &&
      chamada.midia.statuspreavaliacao
    ) {
      const options = midiainfo(
        chamada.midia.statuspreavaliacao,
        chamada.midiainfo,
      );
      dispatch(show(options));
    }
  }, [dispatch, chamada]);

  const handleSemCC = useCallback(async () => {
    if (chamada) {
      const optionBase = {
        type: 'question',
        text: `Cancelar Closed Caption de ${chamada.retranca} ?`,
        confirmButtonText: 'CONFIRMAR',
        callback: {
          url: `/midias/${chamada.midia.id}`,
          method: api.put,
          data: { statuscaption: StatusCaption.SEMCC },
          action: 'successCC',
        },
        haveCallback: true,
        successMessage: 'Edição de CC cancelada!',
        cancelButtonText: 'NÃO',
        showCancelButton: false,
        showConfirmButton: true,
        showCloseButton: true,
      };
      dispatch(show(optionBase));
    }
  }, [chamada, dispatch]);

  const handleSolicitaArquivamento = useCallback(async () => {
    if (chamada) {
      const optionBase = {
        type: 'question',
        text: `Solicitar arquivamento de ${chamada.retranca}?`,
        confirmButtonText: 'CONFIRMAR',
        callback: {
          url: `/arquivamento/${chamada.id}/statusarquivo`,
          method: api.patch,
          data: { statusarquivo: StatusArquivo.SOLICITADO },
          action: 'arquivamento',
        },
        haveCallback: true,
        successMessage: 'Solicitado arquivamento da mídia!',
        cancelButtonText: 'NÃO',
        showCancelButton: false,
        showConfirmButton: true,
        showCloseButton: true,
      };
      dispatch(show(optionBase));
    }
  }, [chamada, dispatch]);

  const handleDeleteAvaliador = useCallback(
    async aprovador => {
      setSelectedAprovador(aprovador);
      const optionBase = {
        type: 'question',
        text: `Remover aprovador ${aprovador.usuario.nome} ?`,
        confirmButtonText: 'CONFIRMAR',
        callback: {
          url: `/chamadaaprovador/${aprovador.id}`,
          method: api.delete,
        },
        haveCallback: true,
        successMessage: 'Avaliador removido!',
        cancelButtonText: 'NÃO',
        showCancelButton: false,
        showConfirmButton: true,
        showCloseButton: true,
      };
      dispatch(show(optionBase));
    },
    [dispatch],
  );

  const handleAddAprovadores = useCallback(
    async _data => {
      if (!!_data && _data.aprovador) {
        setLoadingAprovador(true);
        try {
          const data = Object.assign({
            chamada_id: chamadaId,
            aprovador_id: _data.aprovador,
          });

          const response = await api.post('/chamadaaprovador', data);
          setChamada(
            prevState =>
              prevState && {
                ...prevState,
                aprovadores: [
                  ...prevState.aprovadores,
                  response.data.aprovador,
                ],
                logs: [...prevState.logs, response.data.timeline],
              },
          );
          if (formAprovadoresRef.current)
            formAprovadoresRef.current.clearField('aprovador');
          toast.success('Avaliador adicionado');
          setLoadingAprovador(false);
        } catch (error) {
          if (error instanceof Error) {
            toast.error(error.message);
          } else {
            const appError = error as AppError;
            toast.error(appError.message);
          }

          if (formAprovadoresRef.current)
            formAprovadoresRef.current.clearField('aprovador');
          setLoadingAprovador(false);
        }
      }
    },
    [chamadaId],
  );

  const handleSubmitEnviar = useCallback(e => {
    e.preventDefault();
    if (formFinalizarRef.current) formFinalizarRef.current.submitForm();
  }, []);

  const handleEnviarEng = useCallback(
    async data => {
      try {
        setLoadingSubmit(true);
        if (formFinalizarRef.current) formFinalizarRef.current.setErrors({});
        await schema.validate(data, { abortEarly: false });

        await api.put(`/chamadas/${chamadaId}`, {
          ...data,
          email: {
            destinatarios: data.emails
              .map((e: EmailOption) => e.label)
              .join(', '),
            mensagem: data.observacao,
          },
          emissora: data.emissora_ids,
          status: Status.ENTREGUE,
        });
        setChamada(
          prevState =>
            prevState && {
              ...prevState,
              status: 'entregue',
            },
        );
        toast.success('Material enviado para avaliação da engenharia');
        navigate('/chamadas/aprovacao');
      } catch (err) {
        console.log(err);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          if (formFinalizarRef.current)
            formFinalizarRef.current.setErrors(errors);
          toast.error(err.message);
        } else if (err instanceof Error) {
          toast.error(err.message);
        } else {
          const appError = err as AppError;
          toast.error(appError.message);
        }
      }
    },
    [chamadaId],
  );

  const handleChangeStatus = useCallback(
    async status => {
      try {
        setLoadingStatus(true);
        const response = await api.put(`/chamadas/${chamadaId}`, { status });

        setChamada(
          prevState =>
            prevState && {
              ...prevState,
              status: response.data.status,
              logs: [
                ...prevState.logs,
                {
                  _id: uniqueId(),
                  tipo: 'etapach',
                  chamada_id: prevState.id,
                  mensagem: `Alterado o status da retranca ${prevState.retranca} de ${prevState.status} para ${status}`,
                  createdAt: new Date().toISOString(),
                  usuario: {
                    avatar_url: profile.avatar_url,
                    id: profile.id,
                    nome: profile.nome,
                    avatar: profile.avatar,
                  },
                },
              ],
              aprovadores: prevState.aprovadores.map(aprovador =>
                status === 'aprovacao' && prevState.status === 'alteracao'
                  ? { ...aprovador, status: 'pendente', observacao: null }
                  : { ...aprovador },
              ),
            },
        );
        setLoadingStatus(false);
        toast.success(`Status alterado para: ${status}`);
      } catch (error) {
        setLoadingStatus(false);
        if (error instanceof AppError) {
          const { statusCode, message: text } = error;
          switch (statusCode) {
            case 403:
              dispatch(show({ type: 'error', text }));
              break;
            case 406:
              dispatch(show({ type: 'error', text }));
              dispatch(
                show({
                  type: 'error',
                  text: text || 'Erro inesperado',
                  showCancelButton: false,
                  showConfirmButton: true,
                  showCloseButton: true,
                  confirmButtonText: 'OK',
                  allowOutsideClick: true,
                }),
              );
              break;
            default:
              toast.error(text);
              break;
          }
        } else {
          if (error instanceof Error) {
            toast.error(error.message);
          } else {
            const appError = error as AppError;
            toast.error(appError.message);
          }
        }
      }
    },
    [chamadaId, dispatch, profile],
  );

  const handleSubmitDescricao = useCallback(
    async data => {
      if (formDescricaoRef.current) {
        setLoadingSubmit(true);
        try {
          formDescricaoRef.current.setErrors({});

          const response = await api.patch(
            `/chamadasts/${chamadaId}/descricao`,
            {
              descricao: data.descricao,
            },
          );
          if (response && response.data.chamada) {
            setLoadingSubmit(false);
            setChamada(prevState => ({
              ...prevState,
              descricao: response.data.chamada.descricao,
            }));

            toast.success('Informações salvas com sucesso');
          } else toast.error('Falha de comunicação com o sistema');

          hideModal();
        } catch (error) {
          if (error instanceof Yup.ValidationError) {
            const errors = getValidationErrors(error);
            formDescricaoRef.current.setErrors(errors);
          }
          if (error instanceof Error) {
            toast.error(error.message);
          }
        }
        setLoadingSubmit(false);
      }
    },
    [chamadaId, hideModal],
  );

  const renderDescricao = useCallback(
    descricao => {
      const initialData = {
        descricao: descricao,
      };
      return (
        <PerfectScrollbar style={{ maxHeight: 'calc(100vh - 250px)' }}>
          <Form
            ref={formDescricaoRef}
            onSubmit={handleSubmitDescricao}
            initialData={initialData}
          >
            <div>
              <Input placeholder="Descrição" name="descricao" height={150} />
            </div>
            <div className="actions">
              <Button
                color="default"
                onClick={e => {
                  e.preventDefault();
                  hideModal();
                }}
              >
                CANCELAR
              </Button>
              <Button type="submit" color="primary">
                CONFIRMAR
              </Button>
            </div>
          </Form>
        </PerfectScrollbar>
      );
    },
    [handleSubmitDescricao, hideModal],
  );
  // criar novo formref pra descricao
  const handleDescricao = useCallback(
    chamada => {
      showModal({
        title: 'DESCRIÇÃO',
        component: renderDescricao(chamada.descricao),
        width: '50vw',
      });
    },
    [renderDescricao, showModal],
  );

  const handlePlayer = useCallback(
    previewurl => {
      if (previewurl) {
        setPlayer({
          open: !player.open,
          midia_url: previewurl,
          pipe: false,
        });
      } else {
        dispatch(
          show({
            type: 'warning',
            text: 'Preview indisponível no momento',
            allowOutsideClick: false,
            cancelButtonText: 'OK',
            showConfirmButton: false,
          }),
        );
      }
    },
    [dispatch, player.open],
  );
  const handleResendMail = useCallback(async () => {
    if (chamada) {
      const optionBase = {
        type: 'question',
        text: `Deseja reenviar o e-mail de ${chamada.retranca} ?`,
        confirmButtonText: 'CONFIRMAR',
        callback: {
          url: `/chamadasmail/${chamada.id}`,
          method: api.post,
          action: 'resendmail',
        },
        haveCallback: true,
        successMessage: 'Solicitado reenvio!',
        cancelButtonText: 'NÃO',
        showCancelButton: false,
        showConfirmButton: true,
        showCloseButton: true,
      };
      dispatch(show(optionBase));
    }
  }, [chamada, dispatch]);

  const updateEmails = useCallback(async () => {
    if (formFinalizarRef.current) {
      const emissorasSel = formFinalizarRef.current.getFieldValue(
        'emissora_ids',
      );
      const emails = formFinalizarRef.current.getFieldValue('emails');

      // Mantém e-mails adicionados manualmente
      const emailNew = emails.filter((e: EmailOption) => e.__isNew__);
      // Filtra conforme emissoras selecionadas
      const _emails = emailsCompleto.filter(
        e =>
          e.emissora &&
          e.emissora.id &&
          emissorasSel.includes(e.emissora.id.toString()),
      );
      // Remove duplicates
      const uniqueEmails = [...new Set(_emails.map(e => e.value))];
      const emailsNormalized = uniqueEmails.map(e => ({
        value: e,
        label: e,
        emissora: null,
        __isNew__: false,
      }));

      formFinalizarRef.current.setFieldValue('emails', [
        ...emailsNormalized,
        ...emailNew,
      ]);
    }
  }, [emailsCompleto]);

  const handleToogleRede = useCallback(
    async e => {
      e.preventDefault();

      if (formFinalizarRef.current)
        if (
          formFinalizarRef.current.getFieldValue('emissora_ids').length === 8
        ) {
          formFinalizarRef.current.clearField('emissora_ids');
        } else {
          formFinalizarRef.current.setFieldValue(
            'emissora_ids',
            emissoras.map(emi => emi.id).join(),
          );
        }
      updateEmails();
    },
    [emissoras, updateEmails],
  );

  // fecha player
  const closeVideo = useCallback(() => {
    setPlayer({
      open: !player.open,
      midia_url: '',
      pipe: false,
    });
  }, [player.open]);

  const copyToClipboard = useCallback(text => {
    const dummy = document.createElement('textarea');
    // to avoid breaking orgain page when copying more words
    // cant copy when adding below this code
    // dummy.style.display = 'none'
    document.body.appendChild(dummy);
    // Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
    dummy.value = text;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
    toast.success('Link copiado na a área de transferência');
  }, []);
  /*
   * FUNÇÕES
   */
  function renderDragButton(
    isDragActive: boolean,
    isDragReject: boolean,
    hasMidia = false,
  ) {
    if (!isDragActive) {
      return (
        <>
          <ButtonUpload>
            <FiUpload />
            <p> {hasMidia ? 'Substituir mídia' : 'Arraste ou clique'}</p>
          </ButtonUpload>
        </>
      );
    }

    if (isDragReject) {
      return (
        <ButtonUploadError>
          <FiX /> <p>Formato não permitido</p>
        </ButtonUploadError>
      );
    }

    return (
      <ButtonUpload>
        <FiUpload /> <p>Solte o arquivo</p>
      </ButtonUpload>
    );
  }

  /**
   * USE CALLBACK
   */
  const handleKeyDown = useCallback(
    event => {
      if (!inputEmail) return;
      if (['Enter', 'Tab', ' '].includes(event.key)) {
        if (validateEmail(inputEmail)) {
          const newEmail = {
            value: inputEmail,
            label: inputEmail,
            __isNew__: true,
          };
          if (formFinalizarRef.current) {
            formFinalizarRef.current.setFieldValue('emails', [
              ...formFinalizarRef.current.getFieldValue('emails'),
              newEmail,
            ]);
          }
          setInputEmail('');
        } else {
          toast.error('Informe um email válido');
        }

        event.preventDefault();
      }
    },
    [inputEmail],
  );

  function renderStatusButton() {
    if (chamada) {
      const { status } = chamada;
      if (loadingStatus) {
        return (
          <Button disabled>
            <Spinner type="ThreeDots" />
          </Button>
        );
      }
      switch (status) {
        case Status.APROVACAO:
          return (
            <Button
              disabled={loadingStatus}
              color="danger"
              onClick={() => handleChangeStatus(Status.ALTERACAO)}
            >
              SOLICITAR ALTERAÇÃO
            </Button>
          );
        case Status.APROVADO:
          return (
            <Button
              disabled={loadingStatus}
              color="success"
              type="submit"
              onClick={e => handleSubmitEnviar(e)}
            >
              ENVIAR PARA ENGENHARIA
            </Button>
          );
        case Status.EMPROCESSO:
          return (
            <Button
              disabled={loadingStatus}
              color="primary"
              onClick={() => handleChangeStatus(Status.APROVACAO)}
            >
              ENVIAR PARA APROVAÇÃO
            </Button>
          );
        case Status.ALTERACAO:
          return (
            <Button
              disabled={loadingStatus}
              color="primary"
              onClick={() => handleChangeStatus(Status.APROVACAO)}
            >
              ENVIAR PARA APROVAÇÃO
            </Button>
          );
        default:
          return <></>;
      }
    }
  }

  const updateFile = useCallback((file, data) => {
    setMxfFile([{ ...file, ...data }]);
  }, []);

  const processUpload = useCallback(
    async selectedFile => {
      if (selectedFile && chamadaId) {
        const data = new FormData();
        data.append('file', selectedFile.file);
        data.append('chamada_id', chamadaId);
        try {
          const response = await api.post(`/midias`, data, {
            timeout: 180000 * 3,
            onUploadProgress: e => {
              const progress = e.total
                ? Math.round((e.loaded * 100) / e.total)
                : 0;
              updateFile(selectedFile, {
                progress,
              });
            },
          });

          updateFile(selectedFile, {
            uploaded: true,
            progress: 100,
            error: false,
          });
          setTimeout(() => setMxfFile([]), 1000);
          setChamada(
            prevState =>
              prevState && {
                ...prevState,
                midia: response.data.midia,
                logs: [...prevState.logs, response.data.timeline],
              },
          );

          toast.success('Mídia carregada com sucesso');
        } catch (e) {
          updateFile(selectedFile.id, {
            error: true,
            progress: 0,
            uploaded: false,
          });
          setTimeout(() => setMxfFile([]), 1000);
          const error = e as AppError;
          if (error.message) {
            const optionBase = {
              type: 'error',
              text: error.message,
            };
            dispatch(show(optionBase));
          }
        }
      }
    },
    [chamadaId, dispatch, updateFile],
  );

  const handleUpload = useCallback(
    files => {
      const filesFormatted: MXFFile[] = files.map((file: File) => ({
        file,
        id: uniqueId(),
        name: file.name,
        readableSize: filesize(file.size),
        progress: 0,
        uploaded: false,
        preview: URL.createObjectURL(file),
        error: false,
      }));

      setMxfFile([...filesFormatted]);

      filesFormatted.map(file => processUpload(file));
    },
    [processUpload],
  );

  const handleDragReject = useCallback(
    files => {
      if (files) {
        const file = files[0];
        let text = '';
        const ext = file.name.split('.')[1];
        if (file.type) {
          text = `Não é permitido o envio de arquivo com extensão .${ext}`;
        } else {
          if (ext === 'mxf') {
            text = `Não permitido, solicite a instalação do SONY XDCAM VIEWER com a engenharia local0 para poder fazer envio de arquivos .${ext}`;
          } else {
            text = `Não é permitido o envio de arquivo com extensão .${ext}`;
          }
        }

        dispatch(show({ type: 'error', text }));
      }
    },
    [dispatch],
  );

  /**
   * USE MEMO
   */

  const inUpload = useMemo(
    () =>
      !!mxfFile &&
      mxfFile.length > 0 &&
      !mxfFile[0].uploaded &&
      !mxfFile[0].error &&
      mxfFile[0].progress > 0,

    [mxfFile],
  );

  const loadUsuarios = useCallback(async value => {
    // if (value.length > 2) {
    setAsyncLoading(true);
    const response = await api.get('/usuarios', {
      params: { nome: value, avaliador: true },
    });
    setAsyncLoading(false);
    if (response && response.data)
      return response.data.docs.map((usu: Usuario) => ({
        value: usu.id,
        label: usu.nome,
        isDisabled: usu.status === 'inativo',
        ...usu,
      }));
    else {
      toast.error('Falha de comunicação com o sistema');
      return [];
    }
  }, []);

  const formatDestino = useCallback(
    (emissoraIds: number[]) =>
      emissoraIds
        ? emissoraIds.length === 8
          ? 'REDE'
          : emissoras
              .filter(e => emissoraIds.includes(e.id))
              .map(e => e.siglapromo)
              .join()
        : '',
    [emissoras],
  );

  async function loadEmails(
    chamada: IChamada,
    emissora_ids: number[],
  ): Promise<EmailOption[]> {
    let emailsNormalized: EmailOption[] = [];

    const responseEmail = await api.get('/emails/grupos', {
      params: {
        categoria: chamada.setor,
      },
    });

    let _emailsCompleto: Email[] = [];
    if (responseEmail && responseEmail.data)
      _emailsCompleto = responseEmail.data[0].emails;
    // Se for do Tipo Chamada, remove os e-mails de OPEC
    if ([Tipo.CHAMADA, Tipo.AFINACAO].includes(chamada.tipo))
      _emailsCompleto = _emailsCompleto.filter(e => e.setor !== Setor.OPEC);
    if (Tipo.PROMOCIONAL !== chamada.tipo)
      _emailsCompleto = _emailsCompleto.filter(e => e.setor !== 'eventos');
    // Normaliza e-mails
    let _emailsCompletoFiltrado = _emailsCompleto.map(r => ({
      value: r.email,
      label: r.email,
      emissora: r.emissora,
      __isNew__: false,
    }));
    // Adiciona o e-mail do solicitante
    if (chamada.solicitante.email && chamada.solicitante.setor === Setor.OPEC) {
      _emailsCompletoFiltrado = [
        ..._emailsCompletoFiltrado,
        {
          value: chamada.solicitante.email,
          label: chamada.solicitante.email,
          emissora: undefined,
          __isNew__: false,
        },
      ];
    }
    setEmailsCompleto(_emailsCompletoFiltrado);

    if (emissora_ids.length > 0) {
      // Filtra conforme emissoras selecionadas
      const filteredEmails = _emailsCompletoFiltrado.filter(
        e => e.emissora === null || emissora_ids.includes(e.emissora?.id || 0),
      );
      // Remove duplicates
      const uniqueEmails = [...new Set(filteredEmails.map(e => e.value))];
      // Re-normaliza e-mails filtrados (por causa do Set)
      emailsNormalized = uniqueEmails.map(e => ({
        value: e,
        label: e,
        emissora: undefined,
        __isNew__: false,
      }));
    }

    return emailsNormalized;
  }

  const loadChamada = useCallback(async id => {
    setLoading(true);
    try {
      const [response, responseEmissoras] = await Promise.all([
        api.get(`/chamadasts/${id}`),
        api.get(`/emissoras`),
      ]);
      if (responseEmissoras && responseEmissoras.data)
        setEmissoras(
          responseEmissoras.data.map((emi: Emissora) => ({
            id: emi.id,
            label: emi.nome,
            siglapromo: emi.siglapromo,
          })),
        );
      if (response && response.data) {
        const emissora_ids = response.data.chamada.chamadaemissora.map(
          (emi: ChamadaEmissora) => emi.emissora.id,
        );

        let emailsNormalized: EmailOption[] = [];
        // caso for finalizado verifica se a chamada tem emails (salvo em logmails)
        if (
          [Status.FINALIZADO, Status.ENTREGUE].includes(
            response.data.chamada.status,
          ) &&
          response.data.emails
        ) {
          emailsNormalized = response.data.emails;
        }
        // so busca quando a chamada for finalizar
        else if (response.data.chamada.status === Status.APROVADO) {
          emailsNormalized = await loadEmails(
            response.data.chamada,
            emissora_ids,
          );
        }
        setChamada({
          ...response.data.chamada,
          patrocinios: response.data.chamada.patrocinios.sort(
            (a, b) => a.ordem - b.ordem,
          ),
          datainicio: response.data.chamada.datainicio
            ? new Date(response.data.chamada.datainicio)
            : null,
          datafim: response.data.chamada.datafim
            ? new Date(response.data.chamada.datafim)
            : null,
          aprovadores: response.data.aprovadores,
          // emissora: emissoraFormatted,
          emissora_ids: emissora_ids,
          logs: response.data.timeline,
          emails: emailsNormalized,
          midiainfo: response.data?.midiainfo?.midiainfo,
        });
        if ([Tipo.CHAMADA, Tipo.AFINACAO].includes(response.data.chamada.tipo))
          setActiveTabIndex(1);
      } else toast.error('Falha de comunicação com o sistema');
      setLoading(false);
    } catch (error) {
      if (error instanceof Error) {
        toast.error(error.message);
      } else {
        const appError = error as AppError;
        toast.error(appError.message);
      }
      setLoading(false);
    }
  }, []);

  /**
   * USE EFFECT
   */

  // verifica se callback foi realizado com sucesso para então remover item da lista
  useEffect(() => {
    if (callbackDialog && callbackDialog.success) {
      if (callbackDialog.success.action === 'success' && selectedAprovador) {
        // addLog
        setChamada(
          prevState =>
            prevState && {
              ...prevState,
              aprovadores: prevState.aprovadores.filter(
                aprovador => aprovador.id !== selectedAprovador.id,
              ),

              logs: [...prevState.logs, callbackDialog.success.data.timeline],
            },
        );
      }

      if (callbackDialog.success.action === 'successCC') {
        // addLog
        setChamada(
          prevState =>
            prevState && {
              ...prevState,
              midia: {
                ...prevState.midia,
                statuscaption: 'semCC',
              },
              logs: [...prevState.logs, callbackDialog.success.data.timeline],
            },
        );
      }
      if (callbackDialog.success.action === 'arquivamento') {
        setChamada(
          prevState =>
            prevState && {
              ...prevState,
              statusarquivo: 'solicitado',
            },
        );
      }
    }
  }, [callbackDialog, selectedAprovador]);

  useEffect(() => {
    const controller = new AbortController();
    if (chamadaId) loadChamada(chamadaId);

    return () => {
      controller.abort();
    };
  }, [chamadaId, loadChamada]);

  function renderMidia() {
    if (loading) {
      return <h1>Carregando</h1>;
    } else if (chamada && Object.keys(chamada).length != 0) {
      return (
        <>
          <Midia>
            <Upload>
              <Dropzone
                accept={{
                  'application/mxf': ['.mxf'],
                }}
                multiple={false}
                onDropRejected={handleDragReject}
                onDropAccepted={handleUpload}
                disabled={
                  chamada.status !== Status.EMPROCESSO &&
                  chamada.status !== Status.ALTERACAO
                }
              >
                {({
                  getRootProps,
                  getInputProps,
                  isDragActive,
                  isDragReject,
                }) => (
                  <DropContainer
                    {...getRootProps()}
                    isDragActive={isDragActive}
                    isDragReject={isDragReject}
                  >
                    {!inUpload && <input {...getInputProps()} />}
                    <ThumbnailContainer
                      $mini={
                        chamada.status !== Status.EMPROCESSO &&
                        chamada.status !== Status.ALTERACAO &&
                        chamada.status !== Status.APROVACAO
                      }
                      disabled={
                        chamada.status !== Status.EMPROCESSO &&
                        chamada.status !== Status.ALTERACAO &&
                        chamada.status !== Status.APROVACAO
                      }
                      inUpload={!!inUpload}
                    >
                      <Image
                        onClick={() => console.log('OI')}
                        src={
                          chamada.midia
                            ? chamada.midia.thumbnail_url
                              ? chamada.midia.thumbnail_url
                              : processImage
                            : ''
                        }
                        loader={<Spinner />}
                        unloader={<img src={notfound} alt="sem thumb" />}
                      />
                      {!inUpload &&
                        (chamada.status === Status.EMPROCESSO ||
                          chamada.status === Status.ALTERACAO) &&
                        renderDragButton(
                          isDragActive,
                          isDragReject,
                          !!chamada.midia,
                        )}
                    </ThumbnailContainer>
                  </DropContainer>
                )}
              </Dropzone>

              {!!mxfFile && mxfFile.length > 0 && (
                <CircularContainer
                  styles={{
                    root: { width: 124 },
                    path: { stroke: '#3358f4' },
                    text: {
                      fill: '#3358f4',
                      fontSize: '22px',
                      fontWeight: 600,
                    },
                  }}
                  text={`${mxfFile[0].progress}%`}
                  strokeWidth={5}
                  value={mxfFile[0].progress}
                />
              )}
            </Upload>
            {chamada.midia && (
              <>
                <Info align="space-between">
                  <ul>
                    <li>
                      <p>DESTINO(S):</p>
                      <strong>{formatDestino(chamada.emissora_ids)}</strong>
                    </li>
                    <li>
                      <p>STATUS BAIXA:</p>
                      <div>
                        <Flag
                          name={chamada.midia.statusbaixa}
                          type={chamada.midia.statusbaixa}
                          tooltip="VIDEO EM BAIXA (COM CLAQUETE)"
                          handleAction={() =>
                            handlePlayer(chamada.midia.preview_url)
                          }
                          icon={
                            chamada.midia.statusbaixa ===
                              StatusBaixa.PROCESSADO &&
                            chamada.midia.preview_url ? (
                              <FiPlay />
                            ) : null
                          }
                          icon2={
                            chamada.midia.statusbaixa ===
                            StatusBaixa.PROCESSADO ? (
                              <FiLink />
                            ) : null
                          }
                          handleAction2={() =>
                            copyToClipboard(chamada.midia.preview_url)
                          }
                        />

                        {/* <Button
                          fill
                          color="font"
                          round
                          size="xsm"
                          tooltip="COPIAR LINK"
                          disabled={
                            chamada.midia.statusbaixa !== StatusBaixa.PROCESSADO
                          }
                          onClick={() =>
                            copyToClipboard(chamada.midia.preview_url)
                          }
                        >
                          <FiLink />
                        </Button> */}
                      </div>
                    </li>

                    <li>
                      <p>STATUS WEB:</p>
                      <div>
                        <Flag
                          type={chamada.web}
                          name={
                            chamada.web === StatusWeb.SEMWEB
                              ? 'SEM VERSÃO WEB'
                              : 'VIDEOWEB'
                          }
                          tooltip="CONVERSÃO PARA WEB (SEM CLAQUETE)"
                          handleAction={() =>
                            handlePlayer(chamada.webpreview_url)
                          }
                          handleAction2={() =>
                            copyToClipboard(chamada.webpreview_url)
                          }
                          icon={
                            chamada.web === StatusWeb.CONVERTIDO &&
                            chamada.webpreview_url ? (
                              <FiPlay />
                            ) : null
                          }
                          icon2={
                            chamada.web === StatusWeb.CONVERTIDO &&
                            chamada.webpreview_url ? (
                              <FiLink />
                            ) : null
                          }
                        />
                        {/* <Button
                          id="web_copy"
                          fill
                          color="font"
                          round
                          size="xsm"
                          onClick={() =>
                            copyToClipboard(chamada.webpreview_url)
                          }
                          disabled={!chamada.webpreview_url}
                        >
                          <FiLink />
                        </Button> */}
                      </div>
                    </li>
                    <li>
                      <p>STATUS CC:</p>
                      <div>
                        <Flag
                          name={chamada.midia.statuscaption}
                          type={chamada.midia.statuscaption}
                          icon={
                            chamada.midia.statuscaption !==
                              StatusCaption.SEMCC &&
                            chamada.midia.statuscaption !==
                              StatusCaption.ENCAPSULADA ? (
                              <FaScrewdriver />
                            ) : null
                          }
                          handleAction={() =>
                            navigate(`/closedcaptioneditor/${chamada.midia.id}`)
                          }
                          icon2={
                            chamada.midia.statuscaption !==
                              StatusCaption.SEMCC &&
                            chamada.midia.statuscaption !==
                              StatusCaption.ENCAPSULADA ? (
                              <FiTrash2 />
                            ) : null
                          }
                          handleAction2={() => handleSemCC()}
                        />
                        {/* <Button
                          id="cc_id"
                          fill
                          color="font"
                          round
                          size="xsm"
                          onClick={() => handleClosedCaption(chamada.midia.id)}
                          disabled={
                            chamada.midia.statuscaption ===
                              StatusCaption.SEMCC ||
                            chamada.midia.statuscaption ===
                              StatusCaption.ENCAPSULADA
                          }
                        >
                          <FaScrewdriver />
                        </Button> */}
                        {/* <Tooltip target="cc_id">GERENCIAR CC</Tooltip> */}
                      </div>
                    </li>
                    <li>
                      <p>PRÉ-AVALIAÇÃO:</p>
                      <div>
                        <Flag
                          name={chamada.midia.statuspreavaliacao}
                          type={chamada.midia.statuspreavaliacao}
                          icon={
                            [
                              StatusPreAvaliacao.APROVADO,
                              StatusPreAvaliacao.REPROVADO,
                              StatusPreAvaliacao.RESSALVA,
                            ].includes(chamada.midia.statuspreavaliacao) ? (
                              <FiInfo />
                            ) : null
                          }
                          handleAction={handleMidiaInfoDialog}
                        />
                      </div>
                    </li>
                    <li>
                      <p>ARQUIVO:</p>
                      <div>
                        <Flag
                          name={chamada.statusarquivo}
                          type={chamada.statusarquivo}
                          icon={
                            chamada.statusarquivo === StatusArquivo.NA ? (
                              <FiArchive />
                            ) : null
                          }
                          handleAction={() => handleSolicitaArquivamento()}
                        />
                      </div>
                    </li>
                  </ul>
                </Info>
              </>
            )}
          </Midia>
          <Aprovacao>
            {chamada.status !== Status.ENTREGUE &&
            chamada.status !== Status.FINALIZADO &&
            chamada.status !== Status.APROVADO ? (
              <>
                <header>
                  <h3>APROVADORES</h3>
                  <Button id="info_id" fill color="font" round>
                    <FiInfo />
                  </Button>
                  <Tooltip target="info_id">Informações adicionais</Tooltip>
                </header>

                <FormAprovadores
                  ref={formAprovadoresRef}
                  onSubmit={handleAddAprovadores}
                >
                  <AsyncSelect
                    searchable
                    name="aprovador"
                    type="avatar"
                    loadOptions={loadUsuarios}
                    placeholder="Digite o nome do aprovador"
                    isClearable
                    isDisabled={loadingAprovador}
                    isLoading={asyncLoading}
                  />
                  <Button
                    type="submit"
                    color="primary"
                    size="sm"
                    disabled={loadingAprovador}
                  >
                    {!loadingAprovador ? <FiPlus /> : <Spinner />}
                  </Button>
                </FormAprovadores>

                <Scroll height="calc(100vh - 600px)">
                  <ListAprovadores>
                    {!!chamada.aprovadores &&
                      chamada.aprovadores.length > 0 &&
                      chamada.aprovadores.map((aprovador, index) => (
                        <Item key={index}>
                          <UserInfo>
                            <Avatar
                              size="36"
                              name={aprovador.usuario.nome}
                              src={aprovador.usuario.avatar_url}
                              round
                            />
                            <span>
                              <p>{aprovador.usuario.nome}</p>
                              <strong>{aprovador.usuario.email}</strong>
                            </span>
                          </UserInfo>
                          <Flag
                            type={aprovador.status}
                            name={aprovador.status}
                          />
                          <Actions>
                            <Button
                              id={`idRemover_${index}`}
                              fill
                              color="font"
                              round
                              onClick={() => handleDeleteAvaliador(aprovador)}
                            >
                              <FiTrash2 />
                            </Button>
                            <Tooltip target={`idRemover_${index}`}>
                              REMOVER
                            </Tooltip>
                          </Actions>
                        </Item>
                      ))}
                  </ListAprovadores>
                </Scroll>
              </>
            ) : (
              <>
                <FormFinalizar
                  ref={formFinalizarRef}
                  initialData={chamada}
                  onSubmit={handleEnviarEng}
                >
                  <h3>PERÍODO DE VEICULAÇÃO: *</h3>
                  <SectionDate>
                    <div>
                      <DatePicker
                        placeholderText="DE"
                        minDate={new Date()}
                        name="datainicio"
                        disabled={
                          chamada.status === Status.FINALIZADO ||
                          chamada.status === Status.ENTREGUE
                        }
                      />
                      <DatePicker
                        placeholderText="ATÉ"
                        minDate={new Date()}
                        name="datafim"
                        disabled={
                          chamada.status === Status.FINALIZADO ||
                          chamada.status === Status.ENTREGUE
                        }
                      />
                    </div>
                  </SectionDate>
                  <Exibidoras>
                    <h3>EXIBIDORAS: *</h3>

                    <Button
                      fill
                      color="primary"
                      size="xsm"
                      onClick={e => handleToogleRede(e)}
                    >
                      REDE ?{' '}
                      {chamada.chamadaemissora.length === 8 ? 'SIM' : 'NÃO'}
                    </Button>
                  </Exibidoras>
                  <Checkbox
                    name="emissora_ids"
                    options={emissoras}
                    disabled={
                      chamada.status === Status.FINALIZADO ||
                      chamada.status === Status.ENTREGUE
                    }
                    handleSelected={updateEmails}
                  />
                  <h3>DADOS DO EMAIL</h3>
                  <SelectCreatable
                    searchable
                    menuPlacement="top"
                    name="emails"
                    // name="teste"
                    isDisabled={
                      chamada.status === Status.FINALIZADO ||
                      chamada.status === Status.ENTREGUE
                    }
                    menuIsOpen={false}
                    placeholder="Digite o email do destinatário"
                    isClearable
                    inputValue={inputEmail}
                    onInputChange={(value: string) => setInputEmail(value)}
                    onKeyDown={handleKeyDown}
                    // onChange={(value: EmailOption[]) =>
                    //   value ? setEmails(value) : setEmails([])
                    // }
                    isMulti
                    errorField=""
                  />

                  <TextArea
                    name="observacao"
                    height="100"
                    placeholder="Mensagem que será exibida no email"
                    disabled={
                      chamada.status === Status.FINALIZADO ||
                      chamada.status === Status.ENTREGUE
                    }
                    icon=""
                    errorField=""
                  />
                </FormFinalizar>
              </>
            )}
          </Aprovacao>
        </>
      );
    }
  }

  return (
    <Container>
      <header>
        <Button color="primary" onClick={() => navigate(-1)}>
          VOLTAR
          <FiArrowLeft />
        </Button>
        <Button
          color="primary"
          onClick={() => navigate(`/chamadas/${chamadaId}`)}
          disabled={!chamada || disableEdit(chamada)}
        >
          EDITAR
          <FiEdit />
        </Button>
      </header>
      <ContentCards>
        <LeftContent>
          <Card padding="15px 0 0 0" height="grid">
            <CardContent>
              {loading ? (
                <h4>Carregando...</h4>
              ) : (
                chamada &&
                Object.keys(chamada).length != 0 && (
                  <ColumnContent columns="1fr" margin="0 15px">
                    <div>
                      <section>
                        <h4>DADOS DA CLAQUETE</h4>
                      </section>
                      <div>
                        <ColumnContent columns="1fr 1fr" margin="0 0 25px 0">
                          <Info>
                            <ul>
                              <li>
                                <p>RETRANCA:</p>
                                <strong
                                  style={{
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                  }}
                                >
                                  {chamada.retranca}
                                </strong>
                              </li>
                              <li>
                                <p>DESCRICAO:</p>
                                <strong>{chamada.descricao}</strong>
                                <Button
                                  onClick={() => handleDescricao(chamada)}
                                  fill
                                  color="font"
                                  round
                                  size="xsm"
                                >
                                  <FiEdit2 />
                                </Button>
                              </li>
                              <li>
                                <p>DURAÇÃO:</p>{' '}
                                <strong>{chamada.duracao}</strong>
                              </li>
                              <li>
                                <p>PROGRAMA:</p>
                                <strong>
                                  {chamada.programa
                                    ? chamada.programa.nome
                                    : '---'}
                                </strong>
                              </li>
                            </ul>
                          </Info>
                          <Info>
                            <ul>
                              <li>
                                <p>ANCINE:</p> <strong>{chamada.ancine}</strong>
                              </li>
                              <li>
                                <p>VEICULAÇÃO:</p>
                                <strong>
                                  {chamada.datainicio && chamada.datafim
                                    ? `DE:${format(
                                        new Date(chamada.datainicio),
                                        'dd/MM/yyyy',
                                      )} ATÉ: ${format(
                                        new Date(chamada.datafim),
                                        'dd/MM/yyyy',
                                      )}`
                                    : 'NÃO DEFINIDA'}
                                </strong>
                              </li>
                              <li>
                                <p>DESTINO:</p>
                                <strong>
                                  {formatDestino(chamada.emissora_ids)}
                                </strong>
                              </li>
                              <li>
                                <Flag
                                  type={chamada.tipo}
                                  name={chamada.tipo}
                                  tooltip="TIPO"
                                />

                                <Flag
                                  type={chamada.status}
                                  name={chamada.status}
                                  tooltip="STATUS DE PRODUÇÃO"
                                />
                              </li>
                            </ul>
                          </Info>
                        </ColumnContent>
                      </div>
                    </div>
                  </ColumnContent>
                )
              )}
            </CardContent>
          </Card>

          {chamada && Object.keys(chamada).length != 0 && (
            <Tabs>
              <Tab
                title="Timeline"
                id={1}
                checked={activeTabIndex === 1}
                onChange={() => setActiveTabIndex(1)}
              >
                <Timeline
                  handleAction={() => {
                    handleResendMail();
                  }}
                  data={chamada.logs || []}
                  height="calc(100vh - 425px)"
                  chamadaId={chamadaId}
                  layout="2-columns"
                  padding="15px 0 0 0"
                />
              </Tab>
              {chamada.tipo !== Tipo.CHAMADA && chamada.tipo !== Tipo.AFINACAO && (
                <Tab
                  title="DADOS PARA PRODUÇÃO"
                  id={2}
                  checked={activeTabIndex === 2}
                  onChange={() => setActiveTabIndex(2)}
                >
                  <Info>
                    <ul>
                      <li>
                        <p>CM DE SAÍDA:</p>{' '}
                        <strong>{chamada.codmaterial}</strong>
                      </li>
                    </ul>
                  </Info>
                  <ColumnContent margin="0 0 0 10px" columns="1fr 1fr">
                    <div>
                      {!!chamada.patrocinios &&
                      chamada.patrocinios.length > 0 ? (
                        <ul>
                          {chamada.patrocinios.map((p, index) => (
                            <PatrocinioItem
                              key={index}
                              flag={
                                p.comercial?.statusdownload || 'indisponivel'
                              }
                            >
                              <div>
                                <span>
                                  CM {p.codmaterial}{' '}
                                  {!p.comercial && (
                                    <i> - aguardando recebimento</i>
                                  )}
                                </span>
                                {p.comercial && (
                                  <>
                                    <p>
                                      {p.comercial.titulo}{' '}
                                      <i>
                                        {p.comercial.cliente
                                          ? `(${p.comercial.cliente.mnemonico}) - ${p.comercial.duracao} seg`
                                          : ''}
                                      </i>
                                    </p>
                                    <strong />
                                  </>
                                )}
                              </div>
                              <div>
                                {p.comercial && (
                                  <>
                                    <Button
                                      fill
                                      color="font"
                                      round
                                      size="xsm"
                                      onClick={() =>
                                        handlePatrocinioInfoDialog(p)
                                      }
                                    >
                                      <FiInfo />
                                    </Button>
                                    <Button
                                      fill
                                      color="font"
                                      round
                                      size="xsm"
                                      onClick={() =>
                                        handlePlayer(
                                          p.comercial?.midia?.preview_url,
                                        )
                                      }
                                    >
                                      <FiPlay />
                                    </Button>
                                  </>
                                )}
                              </div>
                            </PatrocinioItem>
                          ))}
                        </ul>
                      ) : (
                        <Flag type="indisponivel" name="NÃO INFORMADO" />
                      )}

                      {chamada.observacaocomercial && (
                        <DadosProducao>
                          <div>
                            <section>
                              <span>Observações comerciais:</span>
                              <div>
                                <p>{chamada.observacaocomercial}</p>
                              </div>
                              <FiDollarSign />
                            </section>
                          </div>
                        </DadosProducao>
                      )}
                    </div>
                    {(chamada.locucao ||
                      chamada.locucaobase ||
                      (chamada.patrocinios &&
                        chamada.patrocinios.length > 0)) && (
                      <DadosProducao>
                        <div>
                          <section>
                            <span>Locução</span>
                            <div>
                              {chamada.locucao && <p> {chamada.locucao}</p>}
                              {chamada.locucaobase && (
                                <p> {chamada.locucaobase}</p>
                              )}
                              {chamada.patrocinios.map(p => (
                                <p>{p.locucao}</p>
                              ))}
                              {chamada.comunicador && (
                                <h5>por {chamada.comunicador.nome}</h5>
                              )}
                            </div>
                            <AiTwotoneAudio />
                          </section>
                        </div>
                      </DadosProducao>
                    )}
                  </ColumnContent>
                </Tab>
              )}

              {chamada && chamada.roteiropromo && chamada.roteiropromo.roteiro && (
                <Tab
                  title="Roteiro"
                  id={3}
                  checked={activeTabIndex === 3}
                  onChange={() => setActiveTabIndex(3)}
                >
                  <RoteiroScroll>
                    <Interweave
                      content={chamada.roteiropromo.roteiro.replaceAll(
                        'xml:lang',
                        'xmlLang',
                      )}
                    />
                  </RoteiroScroll>
                </Tab>
              )}
            </Tabs>
          )}
        </LeftContent>
        <RightContent>
          <Card>
            <ColumnContent margin="0 15px" columns="1fr">
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                }}
              >
                {!loading && (
                  <>
                    <CardContent>
                      <section>
                        <h4>PREVIEW:</h4>
                      </section>
                      {renderMidia()}
                    </CardContent>

                    {chamada &&
                      chamada.aprovadores &&
                      chamada.aprovadores.length > 0 && (
                        <footer>{renderStatusButton()}</footer>
                      )}
                  </>
                )}
              </div>
            </ColumnContent>
          </Card>
        </RightContent>
      </ContentCards>
      <PlayerBaixa
        open={player.open}
        toggleModal={() => closeVideo()}
        pipe={player.pipe}
        url={player.midia_url}
      />
    </Container>
  );
}
